import script from "./cj.vue?vue&type=script&setup=true&lang=js"
export * from "./cj.vue?vue&type=script&setup=true&lang=js"

import "./cj.vue?vue&type=style&index=0&id=25a6490e&scoped=true&lang=css"

import exportComponent from "D:\\D盘\\桌面\\项目\\王者荣耀后台管理系统\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25a6490e"]])

export default __exports__